# frozen_string_literal: true

module Engine
  module Game
    module G1860
    end
  end
end
